module.exports = __webpack_public_path__ + "img/Chan_Zuckerberg_Logo.1337ed37.png";